import { Link } from "react-router-dom";
import { ArrowUpRight, Info } from "lucide-react";
import { INDUSTRIES } from "../../content/site";
import { Reveal } from "./Reveal";

const SPANS = [
  "md:col-span-2 md:row-span-2", "md:col-span-1 md:row-span-1", "md:col-span-1 md:row-span-2",
  "md:col-span-1 md:row-span-1", "md:col-span-1", "md:col-span-1", "md:col-span-1", "md:col-span-1",
];

export const IndustryBento = ({ detailed = false }) => (
  <div className="grid grid-cols-1 gap-4 md:grid-cols-4 md:auto-rows-[260px]" data-testid="industry-bento">
    {INDUSTRIES.map((ind, i) => (
      <Reveal key={ind.slug} delay={(i % 4) * 0.06} className={`${SPANS[i]} min-h-[300px] md:min-h-0`}>
        <article className="group relative h-full overflow-hidden rounded-3xl bg-[color:var(--navy)]" data-testid={`industry-card-${ind.slug}`}>
          <img src={ind.img} alt={`Symbolbild ${ind.title}`} loading="lazy" className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-105" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0E1C3A]/95 via-[#0E1C3A]/45 to-transparent" />
          <div className="relative flex h-full flex-col justify-end p-6 md:p-7">
            <div className="flex flex-wrap gap-1.5">
              {ind.roles.map((r) => (
                <span key={r} className="rounded-full bg-white/15 px-2.5 py-1 text-[11px] font-medium text-white backdrop-blur">{r}</span>
              ))}
            </div>
            <h3 className={`mt-3 font-bold leading-tight text-white ${i === 0 ? "text-2xl md:text-3xl" : "text-xl"}`}>{ind.title}</h3>
            {(detailed || i === 0) && <p className="mt-2 max-w-md text-sm leading-relaxed text-slate-200">{ind.text}</p>}
            {detailed && ind.note && (
              <p className="mt-3 flex gap-2 text-xs leading-relaxed text-[#B5E3DF]"><Info size={14} className="mt-0.5 shrink-0" />{ind.note}</p>
            )}
          </div>
          {!detailed && (
            <Link to="/branchen" aria-label={`Mehr zu ${ind.title}`} className="absolute inset-0" data-testid={`industry-link-${ind.slug}`}>
              <span className="absolute right-5 top-5 inline-flex h-10 w-10 items-center justify-center rounded-full bg-white/90 text-[color:var(--navy)] opacity-90 transition-transform group-hover:rotate-45">
                <ArrowUpRight size={18} />
              </span>
            </Link>
          )}
        </article>
      </Reveal>
    ))}
  </div>
);
